<div class="my-8 w-full">

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back btnText="Back" (backClick)="goBack()"></app-btn-back>
    </div>

    @if (loading()) {
    <div class="flex flex-col gap-2">
        <app-loading-container></app-loading-container>
        <app-loading-container></app-loading-container>
        <app-loading-container></app-loading-container>
    </div>
    } @else {

    <div class="border-0 w-full mb-6">
        <h1 class="font-bold text-2xl text-primary-500 mb-2">Subscribe to Add-Ons</h1>
        <p class="text-primary-300 text-sm leading-relaxed">
            Customize your {{ groupType() === 'church' ? 'church' : 'school' }} group with extra services. Choose seats
            to
            support more {{ groupType() === 'church' ? 'members' : 'students' }}, scale cloud storage space for lessons
            and media, or buy AI tokens to generate automatic quizzes and lecture notes.
        </p>
    </div>

    <div class="flex flex-col lg:flex-row gap-4 w-full items-start">
        <!-- Products List Column (w-8/12 width) -->
        <div class="w-full lg:w-7/12 flex flex-col gap-4">
            @if (currentPage === subPages.Products) {

            <!-- Billing Interval Toggle -->
            <div class="flex justify-center items-center gap-4 px-2 py-3 bg-gray-50 border border-gray-200 rounded-xl">
                <span [class.font-bold]="billingInterval() === 'month'"
                    class="text-sm text-primary-500 transition-all">Monthly Billing</span>
                <button (click)="billingInterval.set(billingInterval() === 'month' ? 'year' : 'month')"
                    [class.toggle-btn-active]="billingInterval() === 'year'"
                    class="toggle-btn relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none">
                    <span [class.toggle-dot-active]="billingInterval() === 'year'"
                        class="toggle-dot pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out">
                    </span>
                </button>
                <span [class.font-bold]="billingInterval() === 'year'" class="text-sm text-primary-500 transition-all">
                    Yearly Billing <span
                        class="text-xs text-green-600 bg-green-100 border border-green-200 px-2 py-0.5 rounded-full ml-1">Save
                        20%</span>
                </span>
            </div>

            @for (product of products(); track product.id) {
            <div [class]="(isSelected(product.id) || (isSeatsProduct(product.id) && isSeatsSubscribed)) ? 'border-secondary-500 bg-secondary-50 shadow-md' : 'border-gray-200 bg-white shadow-sm'"
                class="rounded-xl p-4 border transition-all duration-300 flex flex-col gap-2">
                <div class="flex flex-col w-full gap-2">
                    <div class="flex flex-row justify-between items-start w-full">
                        <div class="flex flex-row flex-wrap items-center gap-2">
                            @if (product.images && product.images.length > 0) {
                            <img [src]="product.images[0]"
                                class="w-8 h-8 min-2-8 min-h-8 rounded-lg object-cover mr-1 p-1 shrink-0 shadow-sm border border-gray-100"
                                [alt]="product.name" />
                            }
                            <span class="text-lg font-bold text-primary-500">{{ product.name }}</span>
                            @if (isSeatsProduct(product.id)) {
                            <span
                                class="text-xs text-nowrap text-primary-600 bg-primary-50 border border-primary-200 px-2.5 py-0.5 rounded-full font-bold ml-1">
                                {{ formatPrice(getProductCost(product), product.prices[0].currency) }} / {{
                                product.prices[0].recurring?.interval }}
                            </span>
                            } @else if (product.prices[0].unit_amount !== null) {
                            <span
                                class="text-xs text-nowrap text-secondary-600 bg-secondary-50 border border-secondary-200 px-2.5 py-0.5 rounded-full">
                                {{ formatPrice((product.prices[0].unit_amount || 0) / 100, product.prices[0].currency)
                                }} /
                                {{
                                product.prices[0].recurring?.interval }}
                            </span>
                            }
                        </div>

                        <!-- Controls Container next to title, justified-between -->
                        <div class="flex flex-row justify-end items-center shrink-0 transition-all duration-300">
                            @if (isSeatsProduct(product.id)) {
                            @if (!isSeatsSubscribed) {
                            @if (studentCount <= getFreeSeatsCount()) { <div
                                class="flex items-center gap-2 bg-secondary-50 border border-secondary-200 px-4 py-2 rounded-xl text-xs font-bold text-secondary-600 shadow-sm select-none">
                                <i class="fa fa-gift text-sm text-secondary-500"></i>
                                <span>{{ getFreeSeatsCount() }} Free {{ groupType() === 'church' ? 'Members' : 'Seats'
                                    }} Active</span>
                        </div>
                        } @else {
                        <div
                            class="flex items-center gap-2 bg-primary-50 border border-primary-100 px-4 py-2 rounded-xl text-xs font-bold text-primary-600 shadow-sm select-none">
                            <i class="fa fa-lock text-sm text-primary-500"></i>
                            <span>{{ getProductQuantity(product.id) }} {{ groupType() === 'church' ? 'Members' : 'Seats'
                                }} (Locked)</span>
                        </div>
                        }
                        } @else {
                        <div
                            class="flex items-center gap-2 bg-green-50 border border-green-200 px-4 py-2 rounded-xl text-xs font-bold text-green-600 shadow-sm select-none">
                            <i class="fa fa-check text-sm text-green-500"></i>
                            <span>Subscribed</span>
                        </div>
                        }
                        } @else if (product.prices[0].recurring?.usage_type !== 'metered') {
                        @if (getProductQuantity(product.id) === 0) {
                        <app-btn-fab icon="fa fa-plus" (click)="onToggleProduct(product)" tooltip="Select Product"
                            bgColor="bg-primary-500 hover:bg-primary-300" textColor="text-white"
                            class="transition-all duration-300"></app-btn-fab>
                        } @else {
                        <div class="flex flex-col justify-between items-end w-full h-full transition-all duration-300">
                            <div
                                class="flex items-center border border-gray-300 rounded-xl overflow-hidden bg-white shadow-sm h-9 transition-all duration-300">
                                <button
                                    class="bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold px-2.5 h-full transition focus:outline-none focus:ring-0"
                                    (click)="decreaseQuantity(product)">
                                    <i class="fa fa-minus text-xxs"></i>
                                </button>
                                <input type="number" [value]="getProductQuantity(product.id)"
                                    (change)="setQuantity(product, $event)"
                                    class="w-10 text-center font-extrabold text-primary-500 border-none outline-none focus:ring-0 text-xs p-0 h-full appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield]">
                                <button
                                    class="bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold px-2.5 h-full transition focus:outline-none focus:ring-0"
                                    (click)="increaseQuantity(product)">
                                    <i class="fa fa-plus text-xxs"></i>
                                </button>
                            </div>
                        </div>
                        }
                        } @else {
                        @if (getProductQuantity(product.id) === 0) {
                        <app-btn-fab icon="fa fa-plus" (click)="onToggleProduct(product)" tooltip="Select Product"
                            bgColor="bg-primary-500 hover:bg-primary-300" textColor="text-white"
                            class="transition-all duration-300"></app-btn-fab>
                        } @else {
                        <div
                            class="flex items-center border border-gray-300 rounded-xl overflow-hidden bg-white shadow-sm h-9">
                            <button
                                class="bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold px-4 transition focus:outline-none focus:ring-0 flex items-center justify-center gap-1.5 h-9"
                                (click)="onToggleProduct(product)">
                                <i class="fa fa-minus text-xs"></i> <span class="text-xs font-semibold">Deselect</span>
                            </button>
                        </div>
                        }
                        }
                    </div>
                </div>

                <span class="text-xs text-primary-300 leading-relaxed">{{ product?.description }}</span>

                @if (product.prices[0].tiers && product.prices[0].tiers.length > 0) {
                <div
                    class="text-xs text-primary-400 mt-1 flex flex-col gap-0.5 bg-gray-50 p-2.5 rounded-lg border border-gray-100 max-w-sm">
                    <span class="font-semibold text-primary-500">Volume pricing tiers:</span>
                    @for (tier of product.prices[0].tiers; track $index) {
                    <span>
                        •
                        @if (tier.up_to === null) {
                        {{ $index === 0 ? '1+' : (product.prices[0].tiers[$index-1].up_to + 1) + '+' }} {{
                        product.unit_label || 'units' }}:
                        } @else {
                        {{ $index === 0 ? '1' : (product.prices[0].tiers[$index-1].up_to + 1) }} - {{ tier.up_to }}
                        {{
                        product.unit_label || 'units' }}:
                        }
                        @if (tier.flat_amount && tier.flat_amount > 0) {
                        {{ formatPrice(tier.flat_amount / 100, product.prices[0].currency) }} / {{
                        product.unit_label || 'units' }} per {{
                        product.prices[0].recurring?.interval }}
                        } @else {
                        {{ formatPrice((tier.unit_amount || 0) / 100, product.prices[0].currency) }} / {{
                        product.unit_label || 'units' }} per {{ product.prices[0].recurring?.interval }}
                        }
                    </span>
                    }
                </div>
                }

                @if (product.metadata?.helper_text) {
                <p class="text-xxs text-primary-300 mt-0.5 leading-normal italic">
                    * {{ product.metadata.helper_text }}
                </p>
                }

                <div
                    class="flex flex-row flex-nowrap overflow-x-auto gap-3 mt-2 text-xs text-primary-400 font-medium whitespace-nowrap scrollbar-none pb-1">
                    <div class="flex items-center gap-1.5 bg-gray-200 px-3 py-1 rounded-full shrink-0">
                        <i class="fa fa-refresh text-primary-500"></i>
                        <span class="capitalize">{{ product.prices[0].recurring?.interval }}ly billing</span>
                    </div>
                    <div class="flex items-center gap-1.5 bg-gray-200 px-3 py-1 rounded-full shrink-0">
                        <i class="fa fa-usd text-primary-500"></i>
                        <span class="capitalize">Type: {{ product.prices[0].recurring?.usage_type }}</span>
                    </div>
                    @if (product.unit_label) {
                    <div class="flex items-center gap-1.5 bg-gray-200 px-3 py-1 rounded-full shrink-0">
                        <i class="fa fa-tag text-primary-500"></i>
                        <span class="capitalize">Unit: {{ product.unit_label }}</span>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        @empty {
        <div class="text-center py-12 bg-white rounded-xl shadow-sm border border-gray-100">
            <i class="fa fa-shopping-bag text-gray-300 text-4xl mb-3"></i>
            <p class="font-semibold text-primary-300">No Products Available</p>
        </div>
        }
        } @else {
        <!-- Payment Details Inline -->
        <div class="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col gap-6 animate-fade-in">
            <div class="border-b border-gray-100 pb-4">
                <h2 class="text-xl font-bold text-primary-500">Payment Details</h2>
                <p class="text-xs text-primary-300 mt-1">
                    Enter your billing and payment information below to complete your checkout.
                </p>
            </div>

            @if (error()) {
            <div class="bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl flex flex-col gap-2">
                <div class="flex items-start gap-3">
                    <i class="fa fa-exclamation-circle text-lg mt-0.5 shrink-0 text-red-500"></i>
                    <span class="text-sm font-medium">{{ error() }}</span>
                </div>
                @if (!clientSecret() && !useExistingCard) {
                <div class="flex items-center gap-2 mt-1">
                    <button type="button" (click)="initStripeElements()" class="text-xs font-bold px-3 py-1.5 bg-red-100 hover:bg-red-200 text-red-800 rounded-lg transition">
                        <i class="fa fa-refresh mr-1"></i> Retry Loading Card Form
                    </button>
                    <button type="button" (click)="goBack()" class="text-xs font-medium px-3 py-1.5 bg-white border border-red-200 hover:bg-gray-50 text-red-700 rounded-lg transition">
                        Back to Products
                    </button>
                </div>
                }
            </div>
            }

            <!-- Payment Element Container -->
            <div class="flex flex-col gap-2">
                <label class="font-bold text-sm text-primary-500 mb-1">Payment Method</label>
                <div id="payment-element" class="min-h-[150px]">
                    @if (loadingPayment()) {
                    <div class="flex justify-center items-center h-36">
                        <app-loading-container class="w-full"></app-loading-container>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>

    <!-- Totals & Payment Column (w-4/12 width) -->
    <div class="w-full min-w-56 lg:w-5/12 lg:sticky lg:top-6 flex flex-col">
        <div class="bg-white p-4 rounded-xl shadow-sm border border-gray-200 flex flex-col gap-4">
            <div>
                <h3 class="font-bold text-lg text-primary-500 border-b border-gray-100 pb-3">Checkout Summary</h3>
                <p class="text-xs text-primary-300 mt-2 leading-relaxed">
                    Verify the total pricing and configure your payment method. Totals include standard UAE 5% VAT where
                    applicable.
                </p>
            </div>

            <!-- Selected Products List -->
            <div class="flex flex-col gap-3">
                <h4 class="text-xs font-bold text-primary-400 uppercase tracking-wider">Selected Add-Ons</h4>
                @if (selectedProductIds.length === 0) {
                <p class="text-xs text-primary-300 italic py-2">No products selected yet.</p>
                } @else {
                <div class="flex flex-col gap-3 divide-y divide-gray-50">
                    @for (product of products(); track product.id) {
                    @if (isSelected(product.id)) {
                    <div class="flex flex-row justify-between items-center pt-2 first:pt-0">
                        <div class="flex flex-col">
                            <span class="font-semibold text-sm text-primary-500">{{ product.name }}</span>
                            <span class="text-xs text-primary-300 capitalize">
                                @if (isSeatsProduct(product.id)) {
                                {{ getProductQuantity(product.id) }} seats
                                } @else {
                                {{ getProductQuantity(product.id) }} x {{ product.unit_label || 'unit' }}{{
                                getProductQuantity(product.id) !== 1 ? 's' : '' }}
                                }
                            </span>
                        </div>
                        <span class="font-bold text-sm text-primary-500">
                            {{ formatPrice(getProductCost(product), product.prices[0].currency) }}
                        </span>
                    </div>
                    }
                    }
                </div>
                }
            </div>

            <!-- Promo Code / Voucher Input -->
            @if (selectedProductIds.length > 0) {
            <div class="flex flex-col gap-2 pt-3 border-t border-gray-100/80">
                <div class="flex justify-between items-center">
                    <span class="text-xs font-bold text-primary-500">Have a voucher / promo code?</span>
                    @if (promoCodeApplied()) {
                    <span
                        class="text-xs font-bold text-green-600 bg-green-50 px-2 py-0.5 border border-green-200 rounded-full flex items-center gap-1 animate-pulse">
                        <i class="fa fa-check"></i> Applied
                    </span>
                    }
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <input type="text" [disabled]="promoCodeApplied() || processing" [value]="promoCode()"
                        (input)="onPromoCodeChange($any($event.target).value)" (keydown.enter)="applyPromoCode()"
                        placeholder="Enter code"
                        class="text-xs px-3.5 py-2 border border-gray-200 rounded-xl focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 w-full disabled:bg-gray-50 disabled:text-gray-400 disabled:border-gray-100 transition-all font-semibold" />
                    @if (!promoCodeApplied()) {
                    <button type="button" (click)="applyPromoCode()"
                        [disabled]="!promoCode() || processing || validatingPromoCode()"
                        class="text-xs font-bold px-4 py-2 bg-primary-50 hover:bg-primary-100 text-primary-600 border border-primary-200 rounded-xl transition duration-200 shrink-0 disabled:opacity-50 flex items-center justify-center min-w-16 h-8">
                        @if (validatingPromoCode()) {
                        <i class="fa fa-spinner animate-spin text-sm"></i>
                        } @else {
                        Apply
                        }
                    </button>
                    } @else {
                    <button type="button" (click)="clearPromoCode()" [disabled]="processing"
                        class="text-xs font-bold px-4 py-2 bg-red-50 hover:bg-red-100 text-red-600 border border-red-200 rounded-xl transition duration-200 shrink-0 h-8">
                        Remove
                    </button>
                    }
                </div>
                @if (promoCodeError()) {
                <span class="text-xxs text-red-600 font-semibold px-1 mt-0.5 flex items-center gap-1">
                    <i class="fa fa-exclamation-circle text-red-500"></i> {{ promoCodeError() }}
                </span>
                }
            </div>
            }

            <!-- Totals & VAT Breakdown -->
            @if (selectedProductIds.length > 0) {
            <div class="flex flex-col gap-3 pt-3 border-t border-gray-100">
                @for (tot of getCheckoutTotals(); track tot.currency) {
                <div class="flex flex-col bg-gray-50/50 p-3.5 rounded-xl border border-gray-100/80">
                    <div class="flex justify-between text-xs font-medium text-primary-300">
                        <span>Subtotal</span>
                        <span>{{ formatPrice(tot.subtotal, tot.currency) }}</span>
                    </div>
                    <div class="flex justify-between text-xs font-medium text-primary-300 mt-1.5">
                        <span>Est. 5% VAT</span>
                        <span>{{ formatPrice(tot.vat, tot.currency) }}</span>
                    </div>
                    <div
                        class="flex justify-between text-sm font-bold text-primary-500 mt-3 border-t border-gray-200/50 pt-2.5">
                        <span>Total (Incl. VAT)</span>
                        <span class="text-secondary-600 font-extrabold text-base">
                            {{ formatPrice(tot.total, tot.currency) }}
                        </span>
                    </div>
                </div>
                }
            </div>
            }

            @if (success()) {
            <div
                class="bg-green-50 border border-green-200 text-green-700 px-4 py-4 rounded-xl flex items-center gap-3 animate-fade-in">
                <i class="fa fa-check-circle text-xl text-green-500 animate-bounce"></i>
                <div>
                    <p class="font-bold">Subscription Successful!</p>
                    <p class="text-xs text-green-600">Your products are now active. Redirecting you to billing page...
                    </p>
                </div>
            </div>
            }

            <!-- Actions -->
            <div class="flex flex-col gap-3 pt-4 border-t border-gray-100 mt-2">
                @if (currentPage === subPages.Products) {
                <app-btn-submit actionText="Continue to Payment Details"
                    [isDisabled]="selectedProductIds.length === 0 || (!promoCodeApplied() && getTotalCheckoutPrice() <= 0) || processing"
                    [isLoading]="processing" [fullWidth]="true" icon="fa fa-chevron-right"
                    bgColor="bg-primary-500 hover:bg-primary-600 active:bg-primary-700 disabled:bg-gray-200"
                    (click)="proceedToPayment()">
                </app-btn-submit>
                } @else {
                <app-btn-submit [actionText]="getTotalCheckoutPrice() <= 0 ? 'Confirm & Subscribe' : 'Confirm & Pay'"
                    [isDisabled]="processing || (loadingPayment() && !useExistingCard) || (!clientSecret() && !useExistingCard)" [isLoading]="processing"
                    [fullWidth]="true" [icon]="getTotalCheckoutPrice() <= 0 ? 'fa fa-check' : 'fa fa-lock'"
                    bgColor="bg-secondary-500 hover:bg-secondary-600 active:bg-secondary-700 disabled:bg-gray-200"
                    (click)="confirmSubscription()">
                </app-btn-submit>
                }
            </div>

            <p class="text-xs text-primary-300 text-center leading-normal mt-2">
                By confirming, you authorize recurring charges via Stripe. Cancel anytime from the subscription
                management dashboard.
            </p>
        </div>
    </div>
</div>
}
</div>